import {Fragment,useState} from "react";
import NotificationContext from "./NotificationContext";
import { Transition } from '@headlessui/react'
import { CheckCircleIcon } from '@heroicons/react/24/solid'
import { XCircleIcon } from '@heroicons/react/24/solid'

// eslint-disable-next-line react/prop-types
const NotificationContextProvider = ({children}) =>{
    const [show, setShow] = useState(null);

    //Function to display notification 
    const displayNotification = (title,message,type) => {
        setShow(() => ({ title,message,type,show:true }));

        setTimeout(()=>{
            setShow(null);
        },2000)
    }
    return (
        <NotificationContext.Provider value={{displayNotification}}>
        {children}

      {show && <div aria-live="assertive" className="fixed bottom-3.5 w-full flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start" >
        <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
          <Transition show={show.show} as={Fragment} enter="transform ease-out duration-300 transition" enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2" enterTo="translate-y-0 opacity-100 sm:translate-x-0" leave="transition ease-in duration-100" leaveFrom="opacity-100" leaveTo="opacity-0" >
            <div className={`max-w-[22rem] w-full ${show.type === "success" ? "bg-green-50" : "bg-red-50"} shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden`}>
              <div className="p-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                  {show.type === "success" ?  
                     <CheckCircleIcon className="w-6 text-green-500" aria-hidden="true" /> 
                     : 
                    <XCircleIcon className="w-6 text-red-500" aria-hidden="true" />
                     } 
                  </div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className={`text-sm font-medium capitalize ${show.type === "success" ? "text-green-900" : "text-red-900"}`}>{show.title}</p>
                     <p className={`mt-1 text-sm capitalize ${show.type === "success" ? "text-green-800" : "text-red-800"} `}>{show.message}.</p>
                  </div>
                  <div className="ml-4 flex-shrink-0 flex">
                    <button className={`${show.type === "success" ? "bg-green-50" : "bg-red-50"} rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300`} onClick={() => { setShow(false) }} >
                      <span className="sr-only">Close</span>
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-[22px]"> <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /> </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>}
      </NotificationContext.Provider>
    )
}

export default NotificationContextProvider;